/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Ward_LabelInputs */

const vi_customer_ward_label = /** @type {(inputs: Customer_Ward_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xã / Phường`)
};

/**

* @param {Customer_Ward_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_ward_label = /** @type {((inputs?: Customer_Ward_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Ward_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_ward_label(inputs)
});